export default __webpack_public_path__ + "static/media/Plats_Modifier.0afa3e7c.png";